import React, {Component} from 'react';
import {BrowserRouter as Router, Route, Switch,} from "react-router-dom";
import LoginMain from './components/login/LoginMain';
import MyDashboard from './components/login/MyDashboard';
import PageNotFound from './components/common/PageNotFound';
import './style/font-family.css';
import SvgComponent from './components/common/SvgComponent';
import {loadScript} from "./components/common/Constants";
import './utagUtil';

class App extends Component {

  componentDidMount() {

    loadScript("https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit", 'googleCaptcha');
};

render() {
  return (
      <div className="App">
          <Router basename={process.env.REACT_APP_BASE}>
              <Switch>
                  <Route path="/log-in" exact component={LoginMain}/>
                  <Route path="/dashboard" component={MyDashboard}/>
                  <Route><PageNotFound/></Route>
              </Switch>
              <SvgComponent/>
          </Router>
      </div>
  );
}
}


export default App;
